// src/views/Tarjetas/VerVehiculosTar.jsx
import React, { useEffect, useRef, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";

export default function VerVehiculosTar({
  vehiculo = null, // si ya viene el objeto completo
  vehiculoId = null, // si solo viene el id -> GET /vehiculo/{id}
  onClose = () => {},
}) {
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  // mismo truco que en VerClientes: saltar la 1ª ejecución en DEV
  const devRunRef = useRef(false);

  // normaliza posibles shapes del backend
  const normalizeVehiculo = (src = {}) => ({
    id: src.id ?? null,
    clienteNombre: src.clienteNombre ?? src.cliente ?? "-",
    patente: src.patente ?? src.placa ?? src.matricula ?? "-",
    descripcionModelo:
      src.descripcionModelo ?? src.descripcion ?? src.modelo ?? "-",
    marca: src.marca ?? src.marcaNombre ?? "-",
  });

  useEffect(() => {
    // si ya viene el objeto completo, lo usamos y listo
    if (vehiculo) {
      setData(normalizeVehiculo(vehiculo));
      setCargando(false);
      return;
    }
    // si no hay id, no hay nada que pedir
    if (!vehiculoId) {
      setData(null);
      setCargando(false);
      return;
    }

    // ⛔️ evitar doble fetch en React 18 StrictMode (solo DEV)
    if (process.env.NODE_ENV !== "production") {
      if (!devRunRef.current) {
        devRunRef.current = true;
        return; // la segunda pasada hará el fetch real
      }
    }

    const ac = new AbortController();
    setCargando(true);
    setError("");

    (async () => {
      try {
        const url = apiRoutes.vehiculosConTarjeta.detail(vehiculoId);
        const json = await apiFetchJson(url, { signal: ac.signal });
        if (ac.signal.aborted) return;
        setData(normalizeVehiculo(json));
      } catch (e) {
        if (e?.name === "AbortError") return;
        console.error("[VerVehiculosTar] error:", e);
        setError("No se pudieron cargar los datos del vehículo.");
      } finally {
        if (!ac.signal.aborted) setCargando(false);
      }
    })();

    return () => ac.abort();
  }, [vehiculoId, vehiculo]);

  const v = data ?? {};

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        <div className="modal-header">
          <h2 className="section-title">Datos de Vehículo</h2>
        </div>

        <div className="modal-body">
          {cargando ? (
            <div className="text-center py-12">Cargando...</div>
          ) : error ? (
            <div className="text-red-600 text-center py-12">Error: {error}</div>
          ) : (
            <div className="form-grid">
              <Fila label="Cliente" value={v.clienteNombre} />
              <Fila label="N° de chapa" value={v.patente} />
              <Fila label="Descripción/Modelo" value={v.descripcionModelo} />
              <Fila label="Marca" value={v.marca} />
            </div>
          )}
        </div>

        <div className="modal-footer">
          <div className="flex justify-end">
            <button onClick={onClose} className="btn-fil">
              Nueva consulta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">{value ?? "-"}</div>
    </div>
  );
}
